<template>
  <div>
    <div class="card">
      <header class="header-card is-paddingless pd-2">
        <p>{{ $t('nomenclatureTechnique.field.nomenclature')}}</p>
      </header>
      <div class="card-content">
        <div class="columns is-multiline">
          <input-champs v-for="(property, index) in properties"
            :key="index"
            :property="property"
            :disabled="disabled"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import inputChamps from '@/components/parametrage/nomenclature/inputChamps';
import {
  TEXTE,
  TABLEAU,
} from '@/configuration/jsonEditor/jsonEditorConfig';
import convertValue from '@/services/general/typeConverter';

export default {
  props: {
    schema: {
      type: Object,
      default: () => {},
      required: true,
    },
    value: {
      type: Object,
      default: () => null,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    inputChamps,
  },
  data() {
    return {
      properties: [],
      constantes: {
        TEXTE,
        TABLEAU,
      },
    };
  },
  watch: {
    properties: {
      handler(newProperties) {
        const newValues = newProperties.reduce((acc, val) => {
          acc[val.name] = val.defaultValue;
          return acc;
        }, {});
        this.$emit('input', newValues);
      },
      deep: true,
    },
    schema: {
      handler(newSchema) {
        this.properties = this.initializeProperties(newSchema.properties);
      },
    },
  },
  methods: {
    initializeProperties(properties) {
      const initializedProperties = Object.keys(properties).map((key, index) => {
        const prop = properties[key];
        const val = this.value?.[key] || prop.defaultValue || prop.default || null;
        const type = prop.type;
        return {
          name: key,
          label: prop.label || key,
          type: prop.type,
          arrayValues: prop.type === this.constantes.TABLEAU ? prop.arrayValues : [],
          propertyOrder: prop.propertyOrder || index + 1,
          defaultValue: convertValue(val, type),
        };
      });
      return this.sortProperties(initializedProperties);
    },
    sortProperties(properties) {
      return properties.sort((a, b) => a.propertyOrder - b.propertyOrder);
    },
    updateSchema() {
      const updatedProperties = this.properties.reduce((acc, prop) => {
        acc[prop.name] = {
          label: prop.label,
          type: prop.type,
          propertyOrder: prop.propertyOrder,
          defaultValue: prop.defaultValue,
          arrayValues: prop.arrayValues,
        };
        return acc;
      }, {});
      this.$emit('update:schema', { ...this.schema, properties: updatedProperties });
    },
    updateProperty(updatedProperty, index) {
      this.properties.splice(index, 1, updatedProperty);
      this.updateSchema();
    },
  },
  mounted() {
    this.properties = this.initializeProperties(this.schema.properties);
  },
};
</script>
